export default __webpack_public_path__ + "static/media/4.5f32b338.webp";